import React from "react";
import BuddhaIcon from "../assets/buddha_icon_1.webp";
import "./LoadingComponent.css";

const LoadingComponent = () => {
  return (
    <div className="loading-container">
      <div className="icon-container">
        <img src={BuddhaIcon} alt="Relaxing Icon" className="loading-icon" />
      </div>
      <div className="loading-text">
        Loading<span className="dots"></span>
      </div>
    </div>
  );
};

export default LoadingComponent;
